import { h, Component } from 'preact';
import { getKey, isFunction } from '../../utils/common';
import { EVENT, log } from '../../common/logger';
import CONSTANT from '../../utils/constants';

export default class Iframe extends Component {
  iframe;

  postDataToIframe = data => {
    this.iframe.contentWindow.postMessage(data, '*');
  };

  initialize = () => {
    this.postDataToIframe(this.props.initializeObject);
  };

  postMessageHandler = event => {
    switch (getKey(event, 'data.type')) {
      case CONSTANT.PAY_SUCCES:
      case CONSTANT.PAY_FAIL: {
        let response;
        try {
          response = JSON.parse(getKey(event, 'data.response'));
        } catch (e) {
          response = {};
        }

        log({
          eventType: EVENT.API_STATUS,
          url: getKey(event, 'data.payloadLogData.url'),
          data: response,
          paymentMode: getKey(event, 'data.payloadLogData.paymentMode'),
          channelCode: getKey(event, 'data.payloadLogData.channelCode'),
          bankCode: getKey(event, 'data.payloadLogData.bankCode')
        });

        break;
      }
      case EVENT.PRE_PTC_API_CALL_LOG: {
        log({
          eventType: EVENT.API_INIT,
          url: getKey(event, 'data.payloadLogData.url'),
          paymentMode: getKey(event, 'data.payloadLogData.paymentMode'),
          channelCode: getKey(event, 'data.payloadLogData.channelCode'),
          bankCode: getKey(event, 'data.payloadLogData.bankCode')
        });
        break;
      }
      default:
        break;
    }

    isFunction(this.props.postMessageHandler) && this.props.postMessageHandler(event);
  };

  componentDidMount() {
    this.iframe.onload = this.initialize.bind(this);
    window.addEventListener('message', this.postMessageHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.postMessageHandler);
    this.props.unload && this.props.unload();
  }

  render({ classname, src }) {
    return (
      <div id="ptm-checkout-iframe">
        <iframe className={classname} src={src} ref={frame => (this.iframe = frame)} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/iframe/index.js